var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.002,
    height: 187.856,
    viewBox: "0 0 149.002 187.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1438",
    "data-name": "Group 1438",
    transform: "translate(-1482.998 -17049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M-1150.5,679H-1183V634.966c.327.022.663.034,1,.034a14.4,14.4,0,0,0,10.253-4.247A14.405,14.405,0,0,0-1167.5,620.5a14.405,14.405,0,0,0-4.247-10.253A14.4,14.4,0,0,0-1182,606c-.333,0-.67.011-1,.034V562h32.5a58.132,58.132,0,0,1,22.771,4.6,58.5,58.5,0,0,1,9.937,5.394,58.917,58.917,0,0,1,8.658,7.143,58.921,58.921,0,0,1,7.143,8.658,58.505,58.505,0,0,1,5.394,9.937A58.133,58.133,0,0,1-1092,620.5a58.134,58.134,0,0,1-4.6,22.771,58.505,58.505,0,0,1-5.394,9.937,58.922,58.922,0,0,1-7.143,8.658,58.92,58.92,0,0,1-8.658,7.143,58.51,58.51,0,0,1-9.937,5.394A58.133,58.133,0,0,1-1150.5,679Z",
    transform: "translate(2724 16487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-1452-16702.145a15,15,0,0,1-15-15v-81.654h20.1a6.984,6.984,0,0,1-2.1-5,7,7,0,0,1,7-7,7,7,0,0,1,7,7,6.984,6.984,0,0,1-2.1,5h20.1v81.654a15,15,0,0,1-15,15Z",
    transform: "translate(2949.998 33939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-1616,638.088h0l-15.09,0a10.158,10.158,0,0,0,.1-1.388,10.011,10.011,0,0,0-10-10,10.011,10.011,0,0,0-10,10,10.052,10.052,0,0,0,.1,1.388H-1666V581a14.891,14.891,0,0,1,4.395-10.6A14.9,14.9,0,0,1-1651,566h35v36.37a10.018,10.018,0,0,1,7.444-3.323,10.011,10.011,0,0,1,10,10,10.011,10.011,0,0,1-10,10,10.014,10.014,0,0,1-7.444-3.323v22.365Z",
    transform: "translate(3149 16498.502)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugLogoWhite);
export default __webpack_public_path__ + "static/media/plug-logo-white.5a38b4fac5804d1c437789297800cba1.svg";
export { ForwardRef as ReactComponent };